import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

type ResetPasswordPayload = {
  new_password: string;
  new_password_confirm: string;
  hash: string;
};

type UseResetPasswordMutationParam = (message: string) => void;

export const useResetPasswordMutation = (handleSetErrorMsg: UseResetPasswordMutationParam) =>
  useTypedMutation<ResetPasswordPayload, void>({
    mutationFn: async payload => (await ApiInstance.post(`/password/reset`, payload, ENV.authBaseURL)).data,
    onSuccess: () => null,
    onError: error => handleSetErrorMsg(error.message)
  });
